import { Component, ViewChild, OnInit, Output, EventEmitter } from "@angular/core";
import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { TranslateService } from "../../shared/translate/translate.service";
import { FlatPickrDirective } from "../../plugins/flatpickr/flatpickr.directive";
import { WeGoConfig } from "../../shared/config";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";

@Component({
  selector: 'wego-vat-setting-popup',
  template: require('../views/vat-setting-popup.component.html')
})

export class VatSettingsPopupComponent implements OnInit {
  @ViewChild('vatSettings') public vatSettings: ModalDirective;
  @ViewChild('flatPickrConfigFromDate') public flatPickrConfigFromDate: FlatPickrDirective;
  @Output('onVatConfirm') onVatConfirm = new EventEmitter();
  constructor(private translate: TranslateService
  ) { }

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  flatPickrConfigStart: FlatPickrModel;
  vatDescription: any;
  vatPercentage: any;
  vatStartDate: any;
  LblVatDescriptionError: any;
  LblVatPercentageError: any;
  LblVatStartDateError: any;

  ngOnInit(): void {
    this.vatDescription = "";
    this.vatPercentage = "";
    this.vatStartDate = "";
    this.flatPickrConfigStart = this.SetDefaultFlatPickrConfig();
  }
  public Confirm() {
    let isValid = true;
    isValid = this.Validate();
    if (isValid) {
      this.onVatConfirm.emit({
        vatDescription: this.vatDescription,
        vatPercentage: this.vatPercentage,
        vatStartDate: this.vatStartDate
      });
      this.hide();
    }
  }

  private Validate() {
    var isValid: boolean = true;
    this.ClearErrorMessage();
    if (this.vatDescription == undefined || this.vatDescription == "") {
      this.LblVatDescriptionError = this.translate.instant('LblVatDescriptionError');
      isValid = false;
    }
    if (this.vatPercentage == undefined || this.vatPercentage == "") {
      this.LblVatPercentageError = this.translate.instant('LblVatPercentageError');
      isValid = false;
    }
    if (this.vatStartDate == undefined || this.vatStartDate == "") {
      this.LblVatStartDateError = this.translate.instant('LblVatStartDateError');
      isValid = false;
    }
    return isValid;
  }

  public show() {
    this.vatDescription = "";
    this.vatPercentage = "";
    this.vatStartDate = "";
    this.ClearErrorMessage();
    this.vatSettings.show();
  }

  public hide() {
    this.vatSettings.hide();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
    flatPickrConfig.dateFormat = this.dateFormat;
    return flatPickrConfig;
  }

  private ClearErrorMessage() {
    this.LblVatDescriptionError = "";
    this.LblVatPercentageError = "";
    this.LblVatStartDateError = "";
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vat-setting/component/vat-setting-popup.component.ts